import { Emit, Inject, Options, Prop, Vue, Watch } from "vue-property-decorator";
import { TrustAPI } from "@/shared/modules/trust-api";
import { AppInsights } from "@/trust-atcs-app/appInsights";
import { EventEmitter } from "events";
import store from "@/trust-atcs-app/store";
import FormatDateTimeMixin from '@/shared/mixins/format-datetime';
import LoadingSpinner from "@/shared/components/loading-spinner/index.vue";
import { FormPartBData } from "@/trust-atcs-app/models/form-part-b-data";
import RadioButtonHorizontal from "../questions/radiobutton-horizontal/index.vue";
import RadioButtonVertical from "../questions/radiobutton-vertical/index.vue";
import RadioButtonBranchList from "../questions/radiobutton-branchlist/index.vue";
import RadioButtonSubQuestions from "../questions/radiobutton-subquestions/index.vue";
import { ComplianceForm, PartBFormTrustAccountingRecords } from "@/shared/modules/typescript-trustapi-client/models";
import DropdownWithText from "../questions/dropdown-with-text/index.vue";

@Options({
  components: {
    LoadingSpinner,
    RadioButtonHorizontal,
    RadioButtonVertical,
    RadioButtonBranchList,
    RadioButtonSubQuestions,
    DropdownWithText,
  },
  mixins: [FormatDateTimeMixin],
})
export default class FormPartBTrustAccountingRecords extends Vue {

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  @Prop({ default: false })
  private isSectionLoading!: boolean;

  @Prop()
  private formPartBData!: FormPartBData;

  @Emit('update:isSectionLoading')
  @Emit('validForm')

  @Watch('loadingContent')
  private sectionLoading() {
    this.$emit('update:isSectionLoading', this.loadingContent);
  }

  private ai = new AppInsights;
  private loadingContent = false;
  private errorLoadingContent = false;

  private validMainQuestions: boolean[] = [];
  private trustAccountingRecords: PartBFormTrustAccountingRecords = null as any;

  mounted(): void {
    this.eventCtrl.on('reload-form-b-tar-content', this.loadTrustAccountingRecordsContent);
    this.loadTrustAccountingRecordsContent();
  }

  beforeUnmount(): void {
    this.eventCtrl.removeListener('reload-form-b-tar-content', this.loadTrustAccountingRecordsContent);
  }

  private async loadTrustAccountingRecordsContent(): Promise<void> {
    try {
      this.loadingContent = true;
      const resp: any = await this.apiService.PartBFormApi?.apiV2PartBFormGetTrustAccountingRecordsPost({
        complianceFormId: this.complianceFormB.id,
        updatingKey: this.updatingKey,
        manageSignatoryUpdatingKey: this.signatoriesUpdatingKey
      });
      this.trustAccountingRecords = resp.data.data as PartBFormTrustAccountingRecords;
      this.formPartBData.trustAccountingRecords = this.trustAccountingRecords as any;
      // Sort atcsMainQuestions by order number
      this.formPartBData.trustAccountingRecords.atcsMainQuestions = this.formPartBData.trustAccountingRecords.atcsMainQuestions.sort((a: any, b: any) => a.order - b.order);
      // Sort atcsSubQuestions by order number
      this.formPartBData.trustAccountingRecords.atcsMainQuestions.forEach((q: any) => {
        q.atcsSubQuestions = q.atcsSubQuestions.sort((a: any, b: any) => a.order - b.order);
      });
      // Sort response by order number
      this.formPartBData.trustAccountingRecords.atcsMainQuestions.forEach((q: any) => {
        q.responses = q.responses.sort((a: any, b: any) => a.order - b.order);
      });
      this.validMainQuestions = this.formPartBData.trustAccountingRecords.atcsMainQuestions.map((q: any) => false);
    } catch (err) {
      this.eventCtrl.emit('show-snackbar', 'error', 'Error getting Trust Accounting records');
      this.ai.trackException('Error getting Trust Accounting records: ' + err);
      this.errorLoadingContent = true;
      console.log(err);
    } finally {
      this.loadingContent = false;
    }
  }

  private validForm(): boolean {
    return !this.validMainQuestions.includes(false);
  }

  private validationForm(i: any, isValid: any) {
    this.validMainQuestions[i] = isValid;
    this.$emit('validForm', this.validForm());
  }

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

  get complianceFormB(): ComplianceForm {
    return store.getters.getSelectedComplianceFormB;
  }

  get updatingKey(): string {
    return store.getters.getFormUpdatingKey;
  }

  get signatoriesPracticeCoreId(): number | null {
    return store.getters.getSelectedPracticeCoreId;
  }

  get signatoriesUpdatingKey(): string {
    return store.getters.getSignatoriesUpdatingKey;
  }

}

